/* eslint-disable react/display-name */
import * as React from 'react';

const Minus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M14,8a.94.94,0,0,1-1,1H3A.94.94,0,0,1,2,8,.94.94,0,0,1,3,7H13A.94.94,0,0,1,14,8Z"
      style={{ fill: 'inherit', fillRule: 'evenodd' }}
    />
  </svg>
);

export default Minus;
